@if ((viewModel$ | async)?.product; as product) {
  <wl-sticky-wrapper
    [sticky]="isPlacedOnOrderPage"
    class="mb-2"
    [class.d-block]="!isPlacedOnOrderPage"
  >
    <wl-partial-card
      [wlTrackProduct]="{
        rendering: rendering,
        track: product,
        trackingConfig: trackProductConfig,
        trackMode: trackMode,
      }"
    >
      <ng-container slot="content">
        <p
          class="result-overview-title h4 fw-bold mb-3"
          *scText="fields?.SummaryTitle"
        ></p>
        <ul class="list-unstyled">
          <li class="d-flex align-items-center">
            <fa-icon icon="coins" [fixedWidth]="true"></fa-icon>
            <wl-rich-text-wrapper
              class="d-inline-block"
              [field]="
                fields?.SavingsPerYear
                  | interpolate
                    : {
                        mode: 'rich_text',
                        variables: {
                          savingsPerYear:
                            product.yearlySavings
                            | currency: 'EUR' : 'symbol' : '1.0-0',
                        },
                      }
              "
              ><span></span
            ></wl-rich-text-wrapper>
            <wl-tooltip
              [tooltip]="savingsPerYearTooltip"
              class="ms-1"
            ></wl-tooltip>
          </li>
          <li class="d-flex align-items-center">
            <fa-icon icon="bolt-lightning" [fixedWidth]="true"></fa-icon>
            <wl-rich-text-wrapper
              class="d-inline-block"
              [field]="
                fields?.RecommendedAmountOfPanels
                  | interpolate
                    : {
                        mode: 'rich_text',
                        variables: {
                          recommendedPanels: product.recommendation.amount,
                        },
                      }
              "
              ><span></span
            ></wl-rich-text-wrapper>
            <wl-tooltip
              [tooltip]="recommendedAmountOfPanelsTooltip"
              class="ms-1"
            ></wl-tooltip>
          </li>
          <li class="d-flex align-items-center">
            <fa-icon icon="solar-panel" [fixedWidth]="true"></fa-icon>
            <wl-rich-text-wrapper
              class="d-inline-block"
              [field]="
                fields?.MaximumAmountOfPanels
                  | interpolate
                    : {
                        mode: 'rich_text',
                        variables: {
                          maxPanels: product.maxPanelAmount,
                        },
                      }
              "
              ><span></span
            ></wl-rich-text-wrapper>
            <wl-tooltip
              [tooltip]="maximumAmountOfPanelsTooltip"
              class="ms-1"
            ></wl-tooltip>
          </li>
        </ul>
      </ng-container>
    </wl-partial-card>
  </wl-sticky-wrapper>
}
